module.exports = __webpack_public_path__ + "static/img/zhutu喷雾机.5e52da8.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/products/zhutu喷雾机.png
// module id = LujR
// module chunks = 0